import { DASHBOARD_TOUR_ID } from './dashboardScenario';
import { EXERCISES_TOUR_ID, SETS_TOUR_ID, SHEETS_TOUR_ID, TASK_TOUR_ID } from './exercisesScenario';

/** Every product-tour guide id the app can auto-start. */
export const ALL_TOUR_GUIDE_IDS: readonly string[] = [
  DASHBOARD_TOUR_ID,
  EXERCISES_TOUR_ID.desktop,
  EXERCISES_TOUR_ID.mobile,
  TASK_TOUR_ID.desktop,
  TASK_TOUR_ID.mobile,
  SHEETS_TOUR_ID.desktop,
  SHEETS_TOUR_ID.mobile,
  SETS_TOUR_ID.desktop,
  SETS_TOUR_ID.mobile,
];

/**
 * Legacy screenshot tutorial used `showTutorial === false` for “already onboarded”.
 * Those users must not get the new product tours — treat every current guide as seen.
 */
export const applyShowTutorialMigration = (
  seenGuides: readonly string[],
  showTutorial: boolean | undefined,
): string[] => {
  if (showTutorial !== false) {
    return [...seenGuides];
  }

  const merged = new Set(seenGuides);

  for (const id of ALL_TOUR_GUIDE_IDS) {
    merged.add(id);
  }

  return [...merged];
};
